import request from '@/utils/request'

export function footerOne(params) {
  return request({
    url: '/mall/mallmanage/index/getDocList',
    method: 'post',
    params
  })
}